import { Link } from 'react-router-dom';
import { newsItems } from '@/mocks/news';
import { workItems } from '@/mocks/works';
import { cultureItems } from '@/mocks/culture';

export default function SiteFooter() {
  return (
    <footer className="mt-20 bg-primary-950 text-background-100">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2.5">
              <span className="w-9 h-9 rounded-lg bg-accent-500 text-primary-950 flex items-center justify-center font-heading text-lg font-semibold">
                璃
              </span>
              <span className="font-heading text-xl tracking-[0.14em]">琉璃神社</span>
            </div>
            <p className="mt-5 text-sm leading-7 text-background-100/70 max-w-md">
              琉璃神社是一个专注动漫资讯与文化分享的内容平台。我们相信，热爱值得被认真记录——从新番动态到作品解析，从产业观察到文化漫谈。
            </p>
            <div className="mt-6 flex items-center gap-3">
              <span className="px-3 py-1.5 rounded-full bg-background-50/10 text-[11px] text-background-100/80 whitespace-nowrap">
                资讯 {newsItems.length} 篇
              </span>
              <span className="px-3 py-1.5 rounded-full bg-background-50/10 text-[11px] text-background-100/80 whitespace-nowrap">
                作品 {workItems.length} 部
              </span>
              <span className="px-3 py-1.5 rounded-full bg-background-50/10 text-[11px] text-background-100/80 whitespace-nowrap">
                专题 {cultureItems.length} 个
              </span>
            </div>
          </div>

          <div className="md:col-span-2">
            <h3 className="text-xs tracking-[0.2em] text-background-100/50 font-label uppercase">
              内容分类
            </h3>
            <ul className="mt-4 space-y-2.5 text-sm">
              <li>
                <Link to="/category/news" className="text-background-100/80 hover:text-accent-300 transition-colors cursor-pointer">
                  动漫资讯
                </Link>
              </li>
              <li>
                <Link to="/category/works" className="text-background-100/80 hover:text-accent-300 transition-colors cursor-pointer">
                  动漫作品
                </Link>
              </li>
              <li>
                <Link to="/category/culture" className="text-background-100/80 hover:text-accent-300 transition-colors cursor-pointer">
                  文化专题
                </Link>
              </li>
              <li>
                <Link to="/search" className="text-background-100/80 hover:text-accent-300 transition-colors cursor-pointer">
                  站内搜索
                </Link>
              </li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <h3 className="text-xs tracking-[0.2em] text-background-100/50 font-label uppercase">
              关于本站
            </h3>
            <ul className="mt-4 space-y-2.5 text-sm">
              <li>
                <Link to="/about" className="text-background-100/80 hover:text-accent-300 transition-colors cursor-pointer">
                  网站介绍
                </Link>
              </li>
              <li>
                <Link to="/about#team" className="text-background-100/80 hover:text-accent-300 transition-colors cursor-pointer">
                  团队理念
                </Link>
              </li>
              <li>
                <Link to="/about#contact" className="text-background-100/80 hover:text-accent-300 transition-colors cursor-pointer">
                  联系与合作
                </Link>
              </li>
              <li>
                <Link to="/about#legal" className="text-background-100/80 hover:text-accent-300 transition-colors cursor-pointer">
                  版权声明
                </Link>
              </li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <h3 className="text-xs tracking-[0.2em] text-background-100/50 font-label uppercase">
              联络我们
            </h3>
            <p className="mt-4 text-sm text-background-100/70 leading-7">
              内容投稿、版权合作与媒体联络
            </p>
            <a
              href="mailto:hello@rurishrine.example.com"
              className="mt-2 inline-flex items-center gap-2 text-sm text-accent-300 hover:text-accent-200 transition-colors cursor-pointer"
            >
              <i className="ri-mail-line w-4 h-4 flex items-center justify-center"></i>
              hello@rurishrine.example.com
            </a>
            <div className="mt-5 flex items-center gap-2">
              {['ri-wechat-fill', 'ri-weibo-fill', 'ri-bilibili-fill', 'ri-mail-line'].map((icon) => (
                <span
                  key={icon}
                  className="w-9 h-9 rounded-lg bg-background-50/10 text-background-100/70 flex items-center justify-center"
                >
                  <i className={`${icon} text-base`}></i>
                </span>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-background-50/10 flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
          <p className="text-xs text-background-100/50">
            © 2026 琉璃神社 Ruri Shrine · 本站内容为演示数据，仅用于产品展示
          </p>
          <p className="text-xs text-background-100/40">
            本站部分作品名称、商标归各自权利人所有，内容仅供文化交流与学习参考。
          </p>
        </div>
      </div>
    </footer>
  );
}